// extracted by mini-css-extract-plugin
module.exports = {"main_block":"_20a6C","mainBlock":"_20a6C","page_title":"ohATo","pageTitle":"ohATo","setheight":"EpK4U"};